"use client";

const Dedicated = () => {
  return (
    <section className="relative bg-cover bg-center overflow-hidden py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-10 items-center">
          <img
            src="/images/dedicated/spiral.svg"
            height={272}
            width={686}
            alt="spiral-design"
            className="absolute left-0 top-0 hidden lg:block -z-10 opacity-50"
          />

          {/* Left Column: The Image */}
          <div className="col-span-12 lg:col-span-6 justify-self-center w-full">
            <div className="relative group max-w-sm sm:max-w-md lg:max-w-none mx-auto">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary to-slate-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
              <img
                src="/images/dedicated/private-label.jpg"
                alt="Atlasimex 3D Visualization"
                width={416}
                height={530}
                className="relative mx-auto md:mx-0 rounded-2xl shadow-2xl border border-gray-100 dark:border-slate-800 w-full h-auto"
              />
            </div>
          </div>

          {/* Right Column: The Text */}
          <div className="col-span-12 lg:col-span-6">
            <div className="relative">
              <img
                src="/images/dedicated/comma.svg"
                alt="quote-icon"
                width={200}
                height={106}
                className="absolute -top-16 -left-32 hidden lg:block opacity-10"
              />
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-center lg:text-start lg:leading-tight text-black dark:text-white">
              “Bridging the gap between digital design and{" "}
              <span className="text-primary">physical reality.</span>”
            </h2>

            <p className="text-base sm:text-lg md:text-xl font-medium text-black/55 dark:text-white/70 mt-6 sm:mt-8 text-center lg:text-start leading-relaxed">
              At Atlasimex, we provide the tools to visualize your global brand
              with uncompromising accuracy. Our 3D viewport offers a
              sophisticated environment to audit every curve and color of your
              canister before it leaves the design phase.
            </p>

            <h5 className="mt-8 sm:mt-10 lg:mt-12 lg:pl-32 relative lg:before:block before:hidden before:absolute before:bg-primary before:h-1 before:w-24 before:left-0 before:top-1/2 text-center lg:text-start text-black dark:text-white font-bold tracking-widest uppercase text-xs sm:text-sm">
              The Atlasimex Engine
            </h5>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dedicated;
